// extracted by mini-css-extract-plugin
export default {"scrollContainer":"UserViewDrawer_scrollContainer__aW6Y3"};